import script from "./manage.vue?vue&type=script&setup=true&lang=js"
export * from "./manage.vue?vue&type=script&setup=true&lang=js"

import "./manage.vue?vue&type=style&index=0&id=1412dce2&lang=scss"

const __exports__ = script;

export default __exports__